import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'
import { BALANCE_COLUMNS } from '@features/reports/views/NL/trialBalanceReport/constants/balanceColumns'

import { columnPdfStyles } from '../../../../../../utils/columnPdfStyles'

export const ReportsPdfTableTrialBalanceHeader = () => {
  const { t } = useTranslation()

  return BALANCE_COLUMNS.map((column) => (
    <View style={columnPdfStyles.columnFluid}>
      <Text key={column.key} style={commonPdfTableStyles.headerLabelText}>
        {t(column.label)}
      </Text>
    </View>
  ))
}
